import { useLocation, useParams } from "react-router-dom";

/**
 * PluginEmbedPage renders a plugin's tunnel-served UI inside the app shell,
 * so plugin pages keep the sidebar, topbar, and theme instead of replacing
 * the whole window. The SPA route is /apps/{pluginId}/* and the frame loads
 * the real backend surface /plugins/{pluginId}/* (same origin, so the
 * session cookie authenticates every request the plugin page makes).
 *
 * In-frame navigation deliberately does not rewrite the address bar; the
 * address identifies the plugin, the plugin owns its inner navigation.
 */
export default function PluginEmbedPage() {
  const { pluginId, "*": splat } = useParams();
  const location = useLocation();
  if (!pluginId) {
    return null;
  }
  const src = `/plugins/${pluginId}/${splat ?? ""}${location.search}`;
  return (
    <div className="plugin-embed">
      <iframe className="plugin-embed-frame" title={`${pluginId} plugin`} src={src} />
    </div>
  );
}
